import { render, staticRenderFns } from "./InstructorListItem.vue?vue&type=template&id=7456708c&scoped=true&"
import script from "./InstructorListItem.vue?vue&type=script&lang=js&"
export * from "./InstructorListItem.vue?vue&type=script&lang=js&"
import style0 from "./InstructorListItem.vue?vue&type=style&index=0&id=7456708c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7456708c",
  null
  
)

export default component.exports